<template>
  <div v-if="quoteTypes">
    <h1>New quote</h1>
    <v-alert :value="true" color="info">Select the type of quote you wish to generate:</v-alert>
    <v-select
      label="Quote type"
      v-model="quoteTypeId"
      :items="quoteTypes"
      item-value="id"
      item-text="name"
      outline
    />
    <p>If you wish to overwrite an existing quote please enter the id below otherwise leave blank:</p>
    <v-text-field label="Quote id overwrite" v-model="overwriteId" outline />
    <v-btn @click="navigate">
      Next
      <v-icon>chevron_right</v-icon>
    </v-btn>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "NewQuote",
  metaInfo() {
    return {
      title: "New quote",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return { quoteTypes: null, quoteTypeId: null, overwriteId: null };
  },
  methods: {
    fetchQuoteTypes() {
      nbmlaw
        .get(`/cors/admin/sales/quoteTypes`)
        .then(response => {
          // console.log(response.data);
          this.quoteTypes = response.data;
        })
        .catch(() => {});
    },
    navigate() {
      this.$router.push({
        name: "quoteQuestions",
        params: { quoteTypeId: this.quoteTypeId },
        query: { overwriteId: this.overwriteId }
      });
    }
  },
  watch: {
    quoteTypes: {
      handler() {
        this.quoteTypeId = this.quoteTypes ? this.quoteTypes[0].id : undefined;
      }
    }
  },
  created() {
    this.fetchQuoteTypes();
  }
};
</script>